<template>
    <v-row
        @mouseenter="hover = true"
        @mouseleave="hover = false"
        class="mx-0 meeting"
        :class="{ 'expanded' : expanded }"
        align="center">
        <v-col cols="1" class="text-center">
            <v-icon :color="changedValues.type ? 'primary' : undefined" @click="meeting.type = toggleType(meeting)">
                {{ $store.state.meetings.typeMap[meeting.type] }}
            </v-icon>
        </v-col>
        <v-col cols="2" class="text-center">
            {{ fullName(meeting) }}
        </v-col>
        <v-col cols="1" class="text-center" :class="{'changed' : changedValues.phone}" >
            <v-text-field v-model="meeting.phone" />
        </v-col>
        <v-spacer />
        <v-col cols="2" class="text-center" :class="{'changed' : changedValues.offerClosedDate}">
            <date-picker
                :date="meeting.offerClosedDate"
                @updateDate="meeting.offerClosedDate = $event"
            />
        </v-col>
        <v-spacer />
        <v-col cols="3" class="text-center">
            <v-select
                    :disabled="$store.state.main.access === 'tele'"
                    v-model="meeting.salesAgent"
                    :items="$store.state.meetings.salesAgents" />
        </v-col>
        <v-col cols="2" class="text-center">
            <v-select
                :items="$store.state.meetings.offerStatuses"
                v-model="meeting.offerStatus"
                @change="expanded = true"
                :class="{'changed' : changedValues.offerStatus}"
            />
        </v-col>
        <div :class="{ 'hidden' : !expanded }" style="display: flex; width: 100%">
            <v-col cols="1" />
            <v-col cols="9">
                <v-textarea rows="7" outlined auto-grow label="Kommentar" v-model="meeting.comment" />
            </v-col>
            <v-col cols="2">
                <date-picker
                    label="Behandlingsdato"
                    :date="meeting.offerClosedDate"
                    @updateDate="meeting.offerClosedDate = $event"
                    v-if="meeting.offerStatus === 'closed'"
                />
                <v-select 
                    label="Resultat"
                    v-if="meeting.offerStatus === 'closed'"
                    :items="$store.state.meetings.offerResults"
                    v-model="meeting.offerResult"
                    :class="{'changed' : changedValues.offerResult}"
                    :error-messages="$store.state.meetings.errors.offerResult"
                />
                <v-text-field
                    label="Solgt præmie"
                    v-if="meeting.offerStatus === 'closed' && meeting.offerResult === 'sale'"
                    v-model="meeting.offerValue"
                    :color="changedValues.offerValue ? 'primary' : undefined"
                    :class="{'changed' : changedValues.offerValue}"
                    :error-messages="$store.state.meetings.errors.offerValue"
                />
            </v-col>
        </div>
        <v-btn v-if="hover" small fab class="expand-meeting-button" @click="expanded = !expanded">
            <v-icon v-if="expanded">fa-angle-up</v-icon>
            <v-icon v-else>fa-angle-down</v-icon>
        </v-btn>
    </v-row>
</template>

<script>
import DatePicker from '@/components/datePicker.vue'

export default {
    components: {
        DatePicker
    },
    props: [
        'initialMeeting',
        'agents'
    ],
    data () {
        return {
            meeting: {...this.initialMeeting},
            hover: false,
            expanded: false,
            changedValues: Object.keys(this.initialMeeting).reduce((o, key) => ({ ...o, [key]: false}), {})
        }
    },
    methods: {
        toggleType () {
            if (this.meeting.type === 'tele') this.meeting.type = 'physical'
            else if (this.meeting.type === 'physical') this.meeting.type = 'online'
            else if (this.meeting.type === 'online') this.meeting.type = 'tele'
        },
        fullName (meeting) {
            return (meeting.firstname ? meeting.firstname.split(' ')[0] : '') + ' ' + (meeting.lastname ? meeting.lastname.split(' ')[meeting.lastname.split(' ').length - 1] : '')
        }
    },
    watch: {
        meeting: {
            handler () {
                Object.keys(this.meeting).forEach(key => {
                    if (this.initialMeeting[key] !== this.meeting[key]) this.changedValues[key] = true
                    else this.changedValues[key] = false
                })
                this.$store.state.meetings.updatedMeetings[this.meeting.id] = this.meeting
                this.$store.state.meetings.changedMeetings = true
            },
            deep: true
        }
    }
}
</script>